import { LANGUAGE_OPTIONS } from './index'

export const AGENT_CONFIG = {
  STG: {
    cert: 'HfnDP8hyRpxuc6bjiIi',
    agentId: 'tssw',
    prefix: 'sw0',
  },
  UAT: {
    cert: 'rGjZikeTOMVR9g11RMY',
    agentId: 'tsswuat',
    prefix: 'ts0',
  },
  UAT_AWS05: {
    cert: '8b0Rys7KDln4UDOPPrB',
    agentId: 'tsswaws05demoag1',
    prefix: 'sw5',
  },
  UAT_AWS12: {
    cert: 'CzEcbXzUjkOndKTBi0G',
    agentId: 'tsswuataws12',
    prefix: 'in2',
  },
  AWCA: {
    cert: 'TQv0naoOxKCIJLdAe2C',
    agentId: 'tsswtest', // [Test line] tsqatesthse > tsqatestmg > tsqatestma > tsswtest
    prefix: '0sw',
  },
  AWCA_RP: {
    cert: 'XGUaEq3JESU0ffzzX4d',
    agentId: 'tsswrp', // [RP line] tsqarphse > tsqarpmg > tsqarpma > tsswrp
    prefix: 'rsw',
  },
  AWCA_2: {
    cert: '7hnNHX8EhOVzSIcGRvA',
    agentId: 'qaautotest', // [Test line] neutectest > neumg > neuma > qaautotest
    prefix: 'tet',
  },
  AWCA_RP_2: {
    cert: '14ctYcSqBLsnZhmgNqI',
    agentId: 'qaautotest2', // [RP line] testliveawc > testma > testmma > qaautotest2
    prefix: 'tew',
  },
  AWS03: {
    cert: 'ulUqFICMtcr3f5s25Qq',
    agentId: 'tsswtest', // [Test line] tsqatesthse > tsqatestmg > tsqatestma > tsswtest
    prefix: '0sw',
  },
  AWS03_RP: {
    cert: 'tDSKP5QTbDyVxn0Nszs',
    agentId: 'tsswrp', // [RP line] tsqarphse > tsqarpmg > tsqarpma > tsswrp
    prefix: 'rsw',
  },
  AWS03_2: {
    cert: 'exKReVsYPOVe3mxNYSV',
    agentId: 'qaautotest1', // [Test line] neutectest > neumg > neuma > qaautotest1
    prefix: 'te0',
  },
  AWS03_RP_2: {
    cert: 'bv8vdy4qhaHKCuBUbAQ',
    agentId: 'testtssw', // [RP line] testliveawc > testma > testmma > testtssw
    prefix: 'tt1',
  },
  AWS05: {
    cert: 'cJSveRNxjkOoBvXogHE',
    agentId: 'tsswaws05testag1',
    prefix: 'swr',
  },
  AWS05_RP: {
    cert: 'LBAunwitlfiQukZLZEn',
    agentId: 'tsswaws05rp1',
    prefix: 'tsw',
  },
  AWS06: {
    cert: 'R9usWXrjbYX1a9clqoC',
    agentId: 'tsswtest1',
    prefix: 'ttw',
  },
  AWS06_RP: {
    cert: '8QhkUjtmDkPCV0OsoPK',
    agentId: 'tsswrp',
    prefix: 'tsw',
  },
  AWS06_RP_2: {
    cert: '5j4vSb99DsDfmoqqqDm',
    agentId: 'qaautotest',
    prefix: 'tet',
  },
  AWS12: {
    cert: '',
    agentId: 'tsswtest1',
    prefix: '',
  },
}

export const DEFAULT_BET_LIMIT = JSON.stringify({
  SEXYBCRT: {
    LIVE: {
      limitId: [280301, 280302, 280303],
    },
  },
  VENUS: {
    LIVE: {
      limitId: [280301, 280302, 280303],
    },
  },
  SV388: {
    LIVE: {
      minbet: 1,
      maxbet: 1000,
      mindraw: 1,
      maxdraw: 100,
      matchlimit: 1000,
    },
  },
  HORSEBOOK: {
    LIVE: {
      minbet: 10,
      maxbet: 3000,
      maxBetSumPerHorse: 10000,
      minorMinbet: 10,
      minorMaxbet: 1000,
      minorMaxBetSumPerHorse: 10000,
    },
  },
  BG: {
    LIVE: {
      limitId: ['H4', 'J4', 'H7'],
    },
  },
  AELIVECOMM: {
    LIVE: {
      limitId: [280301, 280302, 280303],
    },
  },
})

export const USERID_FIELD = [
  {
    id: 'userId',
    label: 'userId',
    defaultValue: undefined,
    element: 'input',
    inputType: 'text',
    maxlength: 21,
    rules: [
      {
        pattern: /^[A-Za-z0-9]+$/,
        message: 'Please enter the correct format',
        trigger: 'blur',
      },
    ],
  },
]

export const BETLIMIT_FIELD = [
  {
    id: 'betLimit',
    label: 'betLimit',
    defaultValue: undefined,
    element: 'textarea',
    inputType: 'text',
    autoSize: { minRows: 3, maxRows: 8 },
    rules: [
      {
        validator: (rule, value) => {
          if (value) {
            try {
              const parseValue = JSON.parse(value)
              return Promise.resolve(parseValue)
            } catch (error) {
              return Promise.reject(new Error('Please enter the correct format'))
            }
          }
          return Promise.resolve()
        },
      },
    ],
  },
]

export const CURRENCY_FIELD = [
  {
    id: 'currency',
    label: 'currency',
    defaultValue: undefined,
    element: 'select',
    options: [],
    showSearch: true,
  },
]

export const LANGUAGE_FIELD = [
  {
    id: 'language',
    label: 'language',
    defaultValue: undefined,
    element: 'select',
    options: LANGUAGE_OPTIONS,
  },
]

export const ISMOBILELOGIN_FIELD = [
  {
    id: 'isMobileLogin',
    label: 'isMobileLogin',
    defaultValue: false,
    element: 'checkbox',
    inputType: 'checkbox',
  },
]

export const EXTERNALURL_ISMOBILELOGIN_AUTOBETMODE_ODDSMODE_FIELDS = [
  {
    id: 'externalURL',
    label: 'externalURL',
    defaultValue: undefined,
    element: 'input',
    inputType: 'text',
    placeholder: '',
    rules: [
      {
        type: 'url',
        message: 'Please enter the correct URL format',
        trigger: 'blur',
      },
    ],
  },
  ...ISMOBILELOGIN_FIELD,
  {
    id: 'autoBetMode',
    label: 'autoBetMode',
    defaultValue: undefined,
    element: 'checkbox',
    inputType: 'checkbox',
  },
  {
    id: 'oddsMode',
    label: 'oddsMode',
    defaultValue: undefined,
    element: 'input',
  },
]

export const CREATE_MEMBER_FORM_FIELDS = [
  {
    id: 'storageLocations',
    label: 'Create Member in',
    defaultValue: ['tssw', 'awc'],
    element: 'checkbox-group',
    options: [
      { label: 'TSSW', value: 'tssw' },
      { label: 'AWC', value: 'awc' },
    ],
    rules: [
      {
        required: true,
        message: 'Required',
      },
    ],
  },
  {
    ...USERID_FIELD[0],
    rules: [
      ...USERID_FIELD[0].rules,
      {
        required: true,
        message: 'Required',
      },
    ],
  },
  ...BETLIMIT_FIELD.map(({ rules, ...f }) => ({
    ...f,
    defaultValue: DEFAULT_BET_LIMIT,
    rules: [
      ...rules,
      // {
      //   required: true,
      //   message: 'Required',
      // },
    ],
  })),
  {
    ...CURRENCY_FIELD[0],
    rules: [
      {
        required: true,
        message: 'Required',
      },
    ],
  },
  {
    ...LANGUAGE_FIELD[0],
    defaultValue: 'en',
  },
  {
    id: 'userName',
    label: 'userName',
    defaultValue: undefined,
    element: 'input',
    maxlength: 20,
    rules: [
      {
        pattern: /^[A-Za-z0-9]+$/,
        message: 'Please enter the correct format',
        trigger: 'blur',
      },
    ],
  },
]

export const UPDATE_BET_LIMIT_FORM_FIELDS = [
  {
    ...BETLIMIT_FIELD[0],
    label: 'Update Bet Limit',
  },
]

export const USER_SETTINGS_FORM_FIELDS = [
  {
    id: 'balance',
    label: 'Update Balance',
    defaultValue: undefined,
    element: 'input-number',
    inputType: 'number',
    placeholder: '',
    min: -9999999999999.999,
    max: 9999999999999.999,
    step: 0.001,
  },
  {
    id: 'betResponse',
    label: 'Bet / BetNSettle Response',
    defaultValue: 'normal',
    element: 'radio-group',
    options: [
      {
        label: 'Normal',
        value: 'normal',
      },
      {
        label: 'Timeout',
        value: 'timeout',
      },
      {
        label: 'status = 9999',
        value: 'status9999',
      },
      {
        label: 'HTTP Code = 400',
        value: 'httpCode400',
      },
      // {
      //   label: 'Null',
      //   value: 'nullBetResponse',
      //   toolTip: 'respond to bet with null',
      // },
      // {
      //   label: 'Without Balance',
      //   value: 'disableBetBalance',
      //   toolTip: 'respond to bet without balance',
      // },
    ],
  },
  {
    id: 'cancelBetResponse',
    label: 'CancelBet / CancelBetNSettle Response',
    defaultValue: 'normal',
    element: 'radio-group',
    options: [
      {
        label: 'Normal',
        value: 'normal',
      },
      {
        label: 'Timeout',
        value: 'timeout',
      },
      {
        label: 'status = 9999',
        value: 'status9999',
      },
      {
        label: 'HTTP Code = 400',
        value: 'httpCode400',
      },
    ],
  },
  {
    id: 'settleResponse',
    label: 'Settle Response',
    defaultValue: 'normal',
    element: 'radio-group',
    options: [
      {
        label: 'Normal',
        value: 'normal',
      },
      {
        label: 'Timeout',
        value: 'timeout',
      },
      {
        label: 'status = 9999',
        value: 'status9999',
      },
      {
        label: 'HTTP Code = 400',
        value: 'httpCode400',
      },
    ],
  },
  {
    id: 'tipResponse',
    label: 'Tip Response',
    defaultValue: 'normal',
    element: 'radio-group',
    options: [
      {
        label: 'Normal',
        value: 'normal',
      },
      {
        label: 'Timeout',
        value: 'timeout',
      },
      {
        label: 'status = 9999',
        value: 'status9999',
      },
      {
        label: 'HTTP Code = 400',
        value: 'httpCode400',
      },
    ],
  },
]
